export default function Pagination ({ paginatorInfo, page, onPageChange, className = '' }) {
  const items = []

  if (!paginatorInfo) {
    return ''
  }

  // Basis Buttons rendern
  const limit = paginatorInfo.lastPage >= 5 ? 5 : paginatorInfo.lastPage

  for (let i = 1; i <= limit; i++) {
    items.push(i)
  }

  return (
    <nav className={className}>
      <ul className="pagination">
        <li className="page-item">
          <a className={`page-link ${page === 1 ? 'disabled' : ''}`}
            href="#"
            onClick={() => onPageChange(page - 1)}
          >&laquo;</a>
        </li>
        { items.map((item, key) => {
          return (
            <li className="page-item"
              key={key}
            >
              <a
                className={`page-link ${page === item ? 'active' : ''}`}
                href="#"
                onClick={() => onPageChange(item)}
              >{ item }</a>
            </li>
          )
        }) }
        { limit >= 5 && (
        <li className="page-item">
          <a
            className="page-link disabled"
            href="#"
          >
            ...
          </a>
        </li>
        )}
        { (limit >= 5 && page >= 5) && (
        <li className="page-item active">
          <a
            className="page-link"
            href="#"
            onClick={() => onPageChange(page)}
          >
            {page}
          </a>
        </li>
        )}
        { (limit >= 5 && page !== paginatorInfo.lastPage) && (
        <li className="page-item">
          <a
            className="page-link"
            href="#"
            onClick={() => onPageChange(paginatorInfo.lastPage)}
          >
            {paginatorInfo.lastPage}
          </a>
        </li>
        )}
        <li className="page-item">
          <a
            className={`page-link ${page === paginatorInfo.lastPage ? 'disabled' : ''}`}
            href="#"
            onClick={() => onPageChange(page + 1)}
          >&raquo;</a>
        </li>
      </ul>
    </nav>
  )
}
